import { translations, type Language } from './translations';

type ControlTextMap = Record<string, string>;

export const CONTROL_TEXT_OVERRIDES_ES: ControlTextMap = {
  // Common controls
  Done: 'Listo',
  Refresh: 'Actualizar',
  'Refreshing...': 'Actualizando...',
  Retry: 'Reintentar',
  Upload: 'Subir',
  Download: 'Descargar',
  Export: 'Exportar',
  Print: 'Imprimir',
  Send: 'Enviar',
  Assign: 'Asignar',
  Acknowledge: 'Reconocer',
  Archive: 'Archivar',
  Publish: 'Publicar',
  Issue: 'Emitir',
  Record: 'Registrar',
  Start: 'Iniciar',
  Stop: 'Detener',
  Open: 'Abrir',
  View: 'Ver',
  Hide: 'Ocultar',
  Filter: 'Filtrar',
  Filters: 'Filtros',
  'Reset filters': 'Restablecer filtros',
  'Clear filters': 'Borrar filtros',
  'Show all': 'Mostrar todo',
  'Show fewer': 'Mostrar menos',
  More: 'Más',
  'Hide more': 'Ocultar más',
  Select: 'Seleccionar',
  'Select all': 'Seleccionar todo',
  'Clear selection': 'Borrar selección',
  'Try again': 'Intentar de nuevo',
  'Open in Telegram': 'Abrir en Telegram',
  'Back to App': 'Volver a la app',
  Cancel: 'Cancelar',
  Close: 'Cerrar',
  Save: 'Guardar',
  Edit: 'Editar',
  Delete: 'Eliminar',
  Clear: 'Borrar',
  Copy: 'Copiar',
  Share: 'Compartir',
  Navigate: 'Navegar',
  Search: 'Buscar',
  Menu: 'Menú',
  Company: 'Compañía',
  Forms: 'Formularios',
  Policies: 'Políticas',
  Records: 'Registros',
  Settings: 'Configuración',
  Favorites: 'Favoritos',
  Add: 'Agregar',
  Trash: 'Papelera',
  'Trash (empty)': 'Papelera (vacía)',
  'Light Mode': 'Modo claro',
  'Dark Mode': 'Modo oscuro',
  'Normal Contrast': 'Contraste normal',
  'High Contrast': 'Alto contraste',
  'Mute Sounds': 'Silenciar sonidos',
  'Enable Sounds': 'Activar sonidos',

  // Company Dashboard navigation
  'Dashboard Menu': 'Menú del panel',
  'Open Company Dashboard menu': 'Abrir menú del panel de compañía',
  Setup: 'Configuración',
  Safety: 'Seguridad',
  Crews: 'Cuadrillas',
  Meetings: 'Reuniones',
  'Job Masters': 'Órdenes maestras',
  'Fleet Manager': 'Administrador de flota',
  Timesheets: 'Hojas de tiempo',
  'Company Records': 'Registros de compañía',
  'Certs & License': 'Certificados y licencias',
  Training: 'Capacitación',
  'Policy Compliance': 'Cumplimiento de políticas',
  'Business Seats': 'Asientos de empresa',

  // Voice Navigation rail and hamburger drawer
  'Open full menu': 'Abrir menú completo',
  'Open Company Dashboard': 'Abrir panel de compañía',
  'Open company meetings': 'Abrir reuniones de compañía',
  'Open Zia Forms': 'Abrir Zia Forms',
  'Open assigned training': 'Abrir capacitación asignada',
  'Open Safety Bulletins': 'Abrir boletines de seguridad',
  'Open History & Records': 'Abrir historial y registros',
  'Offline Mode': 'Modo sin conexión',
  'Voice Search': 'Búsqueda por voz',
  'Voice Search (iOS)': 'Búsqueda por voz (iOS)',
  Recent: 'Reciente',
  'Tap to search again': 'Toca para buscar de nuevo',
  'No type breakdown': 'Sin desglose por tipo',
  'Clear All': 'Borrar todo',
  'All Counties': 'Todos los condados',
  'Search entire New Mexico (139,327 wells)': 'Buscar en todo Nuevo México (139,327 pozos)',
  'Field Work': 'Trabajo de campo',
  'Field Intelligence': 'Inteligencia de campo',
  'History & Records': 'Historial y registros',
  'Crews & Business': 'Cuadrillas y negocio',
  'Support & Sharing': 'Soporte y compartir',
  'App Management': 'Administración de la app',
  'Company Dashboard': 'Panel de compañía',
  'Owner view for crews, records, fleet, safety, and policies': 'Vista del propietario para cuadrillas, registros, flota, seguridad y políticas',
  'Company Policies': 'Políticas de compañía',
  'Review or acknowledge assigned company policies': 'Revisar o reconocer políticas de compañía asignadas',
  'Safety Bulletins': 'Boletines de seguridad',
  'Lessons learned assigned to workers': 'Lecciones aprendidas asignadas a trabajadores',
  'Assigned training, quizzes, and sign-offs': 'Capacitación asignada, cuestionarios y firmas',
  'Time Sheet': 'Hoja de tiempo',
  'Daily labor, shop, and job master time': 'Tiempo diario de labor, taller y órdenes maestras',
  'Request Job Master': 'Solicitar orden maestra',
  'Repair order number for facility work': 'Número de orden de reparación para trabajo en instalaciones',
  'Field, safety, and operator forms': 'Formularios de campo, seguridad y operador',
  'Contractor Guidance': 'Guía para contratistas',
  'Operator PDFs and field requirements': 'PDFs del operador y requisitos de campo',
  'Daily Field Report': 'Reporte diario de campo',
  'OCD Incidents': 'Incidentes OCD',
  'Active Operations': 'Operaciones activas',
  'New Wells Digest': 'Resumen de pozos nuevos',
  'New Wells': 'Pozos nuevos',
  'NM Market Pulse': 'Pulso de mercado de NM',
  'Emissions Leaderboard': 'Tabla de emisiones',
  JSAs: 'JSA',
  'Forms History': 'Historial de formularios',
  'Well Worklists': 'Listas de trabajo de pozos',
  'Submitted Timesheets': 'Hojas de tiempo enviadas',
  'Pre-Trip Inspections': 'Inspecciones antes del viaje',
  'Post-Trip Inspections': 'Inspecciones después del viaje',
  'My Crews': 'Mis cuadrillas',
  'Jobs Board': 'Bolsa de trabajos',
  'Find Services': 'Buscar servicios',
  'Certs & Licenses': 'Certificados y licencias',
  'Suggest a Feature': 'Sugerir una función',
  Support: 'Soporte',
  'Share QR Code': 'Compartir código QR',
  Status: 'Estado',
  'Cloudflare + Zia production': 'Cloudflare + producción Zia',
  'Archived FABs': 'Botones archivados',
  'Help & Tips': 'Ayuda y consejos',
  'Favorites (Star FAB)': 'Favoritos (botón de estrella)',
  'Use Offline Manager to download map tiles and facility data for your basin. Once cached, search and maps work without signal.': 'Usa el administrador sin conexión para descargar mapas y datos de instalaciones de tu cuenca. Una vez en caché, la búsqueda y los mapas funcionan sin señal.',

  // Safety controls
  Dashboard: 'Panel',
  Analytics: 'Analítica',
  'Form Map': 'Mapa de formularios',
  Incidents: 'Incidentes',
  'Corrective Actions': 'Acciones correctivas',
  Recordkeeping: 'Registro',
  Bulletins: 'Boletines',
  Exports: 'Exportaciones',
  'Export audit packet': 'Exportar paquete de auditoría',
  'Reference index only': 'Solo índice de referencias',
  'Include evidence files': 'Incluir archivos de evidencia',
  'Send reminder': 'Enviar recordatorio',
  'Copy reminder': 'Copiar recordatorio',
  'Copy reminders': 'Copiar recordatorios',
  'Save review': 'Guardar revisión',
  'Save investigation': 'Guardar investigación',
  'Create corrective action': 'Crear acción correctiva',
  'Mark in progress': 'Marcar en progreso',
  'Mark completed': 'Marcar completado',
  'Save closeout note': 'Guardar nota de cierre',
  'Export closeout': 'Exportar cierre',

  // Meetings controls
  'Export attendance': 'Exportar asistencia',
  'Export attendance package': 'Exportar paquete de asistencia',
  'Cancel meeting': 'Cancelar reunión',
  'Edit draft': 'Editar borrador',
  RSVP: 'Confirmar asistencia',
  'Check in': 'Registrar entrada',
  'Open meeting': 'Abrir reunión',

  // Fleet controls
  'Fleet / Shop Settings': 'Configuración de flota / taller',
  'Save settings': 'Guardar configuración',
  'Resend to shop': 'Reenviar al taller',
  'Clear routing notice': 'Borrar aviso de ruta',
  'Link asset': 'Vincular activo',
  'Unlink asset': 'Desvincular activo',
  'Upload evidence': 'Subir evidencia',
  'Delete evidence': 'Eliminar evidencia',
  'Export request package': 'Exportar paquete de solicitud',
  'Export asset history': 'Exportar historial del activo',
  'Print summary': 'Imprimir resumen',
  'Complete PM': 'Completar mantenimiento',
  'Send PM reminders': 'Enviar recordatorios de mantenimiento',

  // Policies and training controls
  'Open Company Policies': 'Abrir políticas de compañía',
  'Close Company Policies': 'Cerrar políticas de compañía',
  'Loading company policies': 'Cargando políticas de compañía',
  'Save PDF': 'Guardar PDF',
  'Download PDF': 'Descargar PDF',
  'Assign policy': 'Asignar política',
  'Issue policy': 'Emitir política',
  'View acknowledgements': 'Ver reconocimientos',
  'Export compliance package': 'Exportar paquete de cumplimiento',
  'Export all compliance': 'Exportar todo el cumplimiento',
  'Create revision': 'Crear revisión',
  'Update metadata': 'Actualizar metadatos',
  'Repair layout': 'Reparar diseño',
  'Upload PDF': 'Subir PDF',
  'Generate policy': 'Generar política',
  'Generate pack': 'Generar paquete',
  Preview: 'Vista previa',
  'Close preview': 'Cerrar vista previa',
  'Back to top of company policies': 'Volver arriba en políticas de compañía',
  'Close policy reader': 'Cerrar lector de política',
  'Assign Training': 'Asignar capacitación',
  'Training Catalog': 'Catálogo de capacitación',
  'Completion Matrix': 'Matriz de finalización',
  Catalog: 'Catálogo',
  Matrix: 'Matriz',
  'Archive assignment': 'Archivar asignación',
  'Assign module': 'Asignar módulo',
  'Assign pack': 'Asignar paquete',

  // Search, maps, and FAB controls
  'View in AR': 'Ver en RA',
  'View on Map': 'Ver en el mapa',
  'View on map': 'Ver en el mapa',
  'Back to Favorites List': 'Volver a la lista de favoritos',
  'Facility Chips': 'Tarjetas de instalaciones',
  'Search Facilities': 'Buscar instalaciones',
  AI: 'IA',
  'ZiaWellNav AI Assistant': 'Asistente IA de ZiaWellNav',
  Orthanc: 'Orthanc',
  'AR View': 'Vista RA',
  'Full Radar': 'Radar completo',
  'Production Atlas': 'Atlas de producción',
  'Pre-Trip Inspection': 'Inspección antes del viaje',
  'Post-Trip Inspection': 'Inspección después del viaje',
  'New JSA': 'Nuevo JSA',
  'Cert & License Vault': 'Bóveda de certificados y licencias',
  Receipts: 'Recibos',
  'Map Layers': 'Capas del mapa',
  'View Hazards': 'Ver peligros',
  'Report Road Hazard': 'Reportar peligro en camino',
  'Friends & Amigos': 'Amigos y compañeros',
  'Report Cop Location': 'Reportar ubicación de policía',
  'Safety Reports': 'Reportes de seguridad',
  'Report Flock Camera': 'Reportar cámara Flock',
  'Report PTZ Camera': 'Reportar cámara PTZ',
  'Quick Dial API #': 'Marcación rápida API #',
  'Well Worklist': 'Lista de trabajo de pozos',
  'Quick Reports': 'Reportes rápidos',
  'Field Ops': 'Operaciones de campo',
  'OCD Reports': 'Reportes OCD',
  'SOS / Injury': 'SOS / lesión',
  'HOLD 5s to Call 911': 'Mantén 5s para llamar al 911',
  'RELEASE TO CANCEL': 'Suelta para cancelar',
  'Zia Gives Back - Help Our Community': 'Zia apoya - ayuda a nuestra comunidad',
  'Community Amenities': 'Servicios comunitarios',
  'Browse API Numbers': 'Explorar números API',
  'View Timesheet': 'Ver hoja de tiempo',
  'Food Trucks': 'Food trucks',
  'Marching Orders': 'Órdenes de trabajo',
  'Race Mode': 'Modo carrera',
  'Listening…': 'Escuchando…',
  'Processing Voice': 'Procesando voz',
  'Voice Ready': 'Voz lista',
  'Voice Error': 'Error de voz',
  'Google Maps': 'Google Maps',
  'Open in Google Maps': 'Abrir en Google Maps',
  Photos: 'Fotos',
  'Back to chips': 'Volver a tarjetas',
  'Back to search chips': 'Volver a tarjetas de búsqueda',
  'Close search results': 'Cerrar resultados de búsqueda',
  'Dismiss share dialog': 'Cerrar diálogo de compartir',
  'Dismiss photo gallery': 'Cerrar galería de fotos',
  'Filter by production data': 'Filtrar por datos de producción',
  'Filter by well type': 'Filtrar por tipo de pozo',
  'Zoom In': 'Acercar',
  'Zoom Out': 'Alejar',
  'Quick Photo': 'Foto rápida',
  'Route Photos': 'Fotos de ruta',
  'Add a New Facility': 'Agregar nueva instalación',
  'Loading...': 'Cargando...',
  'Location & Crew ON': 'Ubicación y cuadrilla activadas',
  'Location ON': 'Ubicación activada',
  'Location Controls': 'Controles de ubicación',
  'Weather On': 'Clima activado',
  'Weather Off': 'Clima desactivado',
  'Temperature Loading...': 'Cargando temperatura...',
  'UV Index Loading...': 'Cargando índice UV...',
  'Wind Visible': 'Viento visible',
  'Show Wind': 'Mostrar viento',
  'Rain Data Loading...': 'Cargando datos de lluvia...',
  'Air Quality Loading...': 'Cargando calidad del aire...',
  'Pollen On': 'Polen activado',
  'Pollen Off': 'Polen desactivado',
  'Nearby Services': 'Servicios cercanos',
  'Elevation On': 'Elevación activada',
  'Show Elevation': 'Mostrar elevación',
  'No Route': 'Sin ruta',
  'Hide Settings': 'Ocultar configuración',
  'Job Safety Analysis': 'Análisis de seguridad del trabajo',
  'Add Porta Potty': 'Agregar baño portátil',
  'Add Taco Truck': 'Agregar taco truck',
  'Ghost Mode': 'Modo fantasma',
  Routes: 'Rutas',
  Landmark: 'Punto de referencia',
  'Draw Route': 'Dibujar ruta',
  Windmills: 'Molinos de viento',
  'Show Windmills': 'Mostrar molinos de viento',
  'Data Layers': 'Capas de datos',
  'Loading OCD layer': 'Cargando capa OCD',
  'Active Incidents': 'Incidentes activos',
  'Gas Waste': 'Desperdicio de gas',
  'Pits': 'Fosas',
  'Frac': 'Frac',
  Recycling: 'Reciclaje',
  Seismic: 'Sísmico',
  Karst: 'Karst',
  Basins: 'Cuencas',
  Ownership: 'Propiedad',
  'TX Pipelines': 'Ductos TX',
  'NM Pipelines': 'Ductos NM',
  'TX Permits': 'Permisos TX',
  H2S: 'H2S',
  Violations: 'Infracciones',
  'TX Incidents': 'Incidentes TX',
  'TX Seismic': 'Sísmico TX',
  'Loading Caliche Routes': 'Cargando rutas de caliche',
  'Show Caliche Routes': 'Mostrar rutas de caliche',
  'Caliche Routes ON': 'Rutas de caliche activadas',
  'Reset FAB Layout': 'Restablecer botones flotantes',
  'Help & Support': 'Ayuda y soporte',
  'Offline Maps': 'Mapas sin conexión',
  Weather: 'Clima',
  Receipt: 'Recibo',
  'Add Facility': 'Agregar instalación',
  'Register Business': 'Registrar negocio',
  'Report Safety Inspector': 'Reportar inspector de seguridad',
  'Report DOT Officer': 'Reportar oficial DOT',
  'Report Cop': 'Reportar policía',
  Facilities: 'Instalaciones',
  'Caliche Routes': 'Rutas de caliche',
  Hazards: 'Peligros',
  Amenities: 'Servicios',
  'Data Layers OFF — tap to show Incidents': 'Capas apagadas — toque para mostrar incidentes',
  Layers: 'Capas',
  'Reset Map View': 'Restablecer vista del mapa',
  'Recenter to Basin': 'Centrar en la cuenca',
  'Share via Telegram': 'Compartir por Telegram',

  // Paywall/subscription controls not fully moved into translations yet
  'Full access with Telegram Stars': 'Acceso completo con Telegram Stars',
  'Pay 500 Stars for 30 days': 'Pagar 500 Stars por 30 días',
  'Opening Stars invoice...': 'Abriendo factura de Stars...',
  'Business seats bypass payment': 'Los asientos de empresa evitan el pago',

  // Misc worker/customer controls
  'Upload photo': 'Subir foto',
  'Open tools': 'Abrir herramientas',
  'Close Earth Intel tools': 'Cerrar herramientas Earth Intel',
  'Open market lens': 'Abrir lente de mercado',
  'Open Market': 'Abrir mercado',
  'Search prediction market context': 'Buscar contexto de mercado de predicción',
  'Dismiss info': 'Cerrar información',
  'View Details': 'Ver detalles',
};

const CONTROL_ATTRS = ['aria-label', 'title', 'placeholder'] as const;
const CONTROL_SELECTOR = [
  'button',
  '[role="button"]',
  '[role="menuitem"]',
  '[role="tab"]',
  '[role="switch"]',
  '[role="option"]',
  'option',
  '[aria-label]',
  '[title]',
  'input[placeholder]',
  'textarea[placeholder]',
].join(',');

const EXCLUDED_ANCESTOR_SELECTOR = [
  'script',
  'style',
  'code',
  'pre',
  '[contenteditable="true"]',
  '[data-zwn-i18n-ignore]',
].join(',');

const originalTextNodes = new WeakMap<Text, string>();
const originalAttrs = new WeakMap<Element, Map<string, string>>();

function buildTranslationBackedControlMap(language: Language): ControlTextMap {
  const map: ControlTextMap = {};
  const englishEntries = Object.entries(translations.en) as Array<[keyof typeof translations.en, string]>;
  for (const [key, english] of englishEntries) {
    if (!english || english.includes('{')) continue;
    const translated = translations[language][key];
    if (translated && translated !== english) {
      map[english] = translated;
    }
  }
  if (language === 'es') {
    Object.assign(map, CONTROL_TEXT_OVERRIDES_ES);
  }
  return map;
}

const mapCache = new Map<Language, ControlTextMap>();

export function getUserFacingControlTextMap(language: Language): ControlTextMap {
  if (!mapCache.has(language)) {
    mapCache.set(language, buildTranslationBackedControlMap(language));
  }
  return mapCache.get(language)!;
}

function preserveOuterWhitespace(original: string, translated: string): string {
  const leading = original.match(/^\s*/)?.[0] || '';
  const trailing = original.match(/\s*$/)?.[0] || '';
  return `${leading}${translated}${trailing}`;
}

function translateKnownLabel(language: Language, value: string): string {
  return getUserFacingControlTextMap(language)[value] || value;
}

function translateDynamicControlText(language: Language, value: string): string | null {
  if (language !== 'es') return null;

  const numericResults = value.match(/^([\d,]+)\s+results$/i);
  if (numericResults) return `${numericResults[1]} resultados`;

  const repeatSearch = value.match(/^Repeat search for\s+(.+)$/i);
  if (repeatSearch) return `Repetir búsqueda de ${repeatSearch[1]}`;

  const removeSearch = value.match(/^Remove\s+(.+)\s+from recent searches$/i);
  if (removeSearch) return `Quitar ${removeSearch[1]} de búsquedas recientes`;

  const openCount = value.match(/^Open\s+(\d+)\s+(.+)$/i);
  if (openCount) return `Abrir ${openCount[1]} ${translateKnownLabel(language, openCount[2])}`;

  const attentionCount = value.match(/^(\d+)\s+(.+)\s+items need attention$/i);
  if (attentionCount) return `${attentionCount[1]} elementos de ${translateKnownLabel(language, attentionCount[2])} necesitan atención`;

  const mapStyle = value.match(/^Map Style:\s+(.+)$/i);
  if (mapStyle) return `Estilo de mapa: ${translateKnownLabel(language, mapStyle[1])}`;

  const hiddenFabs = value.match(/^Hidden FABs(?:\s+\((\d+)\))?$/i);
  if (hiddenFabs) return hiddenFabs[1] ? `Botones ocultos (${hiddenFabs[1]})` : 'Botones ocultos';

  const trashCount = value.match(/^Trash\s+\((.+)\)$/i);
  if (trashCount) return `Papelera (${trashCount[1] === 'empty' ? 'vacía' : trashCount[1]})`;

  const vehicle = value.match(/^Vehicle:\s+(.+)\s+-\s+Tap to change$/i);
  if (vehicle) return `Vehículo: ${vehicle[1]} - toca para cambiar`;

  const windmillsOn = value.match(/^Windmills ON\s+\((.+)\)\s+-\s+tap to hide$/i);
  if (windmillsOn) return `Molinos activados (${windmillsOn[1]}) - toca para ocultar`;

  const temp = value.match(/^(-?\d+)°F(.*)$/);
  if (temp) {
    return `${temp[1]}°F${temp[2]
      .replace('Feels', 'Sensación')
      .replace('EXTREME HEAT!', 'CALOR EXTREMO!')
      .replace('Dangerous Heat', 'Calor peligroso')
      .replace('Hot - Hydrate!', 'Calor - hidrátate')
      .replace('Freezing - Ice!', 'Congelación - hielo')
      .replace('Cold', 'Frío')
      .replace('Comfortable', 'Cómodo')}`;
  }

  const uv = value.match(/^UV Index:\s+(.+)$/i);
  if (uv) {
    return `Índice UV: ${uv[1]
      .replace('EXTREME!', 'EXTREMO!')
      .replace('Very High', 'Muy alto')
      .replace('High - Shade', 'Alto - busca sombra')
      .replace('Moderate', 'Moderado')
      .replace('Low', 'Bajo')}`;
  }

  const wind = value.match(/^Wind:\s+(.+)$/i);
  if (wind) {
    return `Viento: ${wind[1]
      .replace('DANGEROUS!', 'PELIGROSO!')
      .replace('High Wind', 'Viento fuerte')
      .replace('Breezy', 'Brisa')
      .replace('Calm', 'Calma')}`;
  }

  const rain = value
    .replace('FLOOD RISK', 'RIESGO DE INUNDACIÓN')
    .replace('Avoid low areas!', 'Evita zonas bajas!')
    .replace('Storm', 'Tormenta')
    .replace('Seek shelter!', 'Busca refugio!')
    .replace('Heavy Rain', 'Lluvia fuerte')
    .replace('Rain', 'Lluvia')
    .replace('Clear', 'Despejado');
  if (rain !== value) return rain;

  const aqi = value.match(/^AQI:\s+(.+)$/i);
  if (aqi) {
    return `ICA: ${aqi[1]
      .replace('HAZARDOUS!', 'PELIGROSO!')
      .replace('Very Unhealthy', 'Muy dañino')
      .replace('Unhealthy', 'Dañino')
      .replace('Sensitive', 'Sensible')
      .replace('Moderate', 'Moderado')
      .replace('Good', 'Bueno')}`;
  }

  const pollen = value.match(/^Pollen:\s+(.+)$/i);
  if (pollen) {
    return `Polen: ${pollen[1]
      .replace('Very High!', 'Muy alto!')
      .replace('High', 'Alto')
      .replace('Moderate', 'Moderado')
      .replace('Low', 'Bajo')
      .replace('Very Low', 'Muy bajo')}`;
  }

  const releaseToCancel = value.match(/^(.+)\.\.\.\s+RELEASE TO CANCEL$/);
  if (releaseToCancel) return `${releaseToCancel[1]}... SUELTA PARA CANCELAR`;

  return null;
}

export function translateUserFacingControlText(language: Language, value: string): string {
  if (language === 'en') return value;
  const trimmed = value.trim();
  if (!trimmed) return value;
  const dynamicTranslation = translateDynamicControlText(language, trimmed);
  if (dynamicTranslation) return preserveOuterWhitespace(value, dynamicTranslation);
  const translated = getUserFacingControlTextMap(language)[trimmed];
  return translated ? preserveOuterWhitespace(value, translated) : value;
}

function isExcluded(element: Element | null): boolean {
  return Boolean(element?.closest(EXCLUDED_ANCESTOR_SELECTOR));
}

function isControlTextNode(node: Text): boolean {
  const parent = node.parentElement;
  return Boolean(parent?.closest(CONTROL_SELECTOR)) && !isExcluded(parent);
}

function translateTextNode(node: Text, language: Language): void {
  if (!isControlTextNode(node)) return;

  if (language === 'en') {
    const original = originalTextNodes.get(node);
    if (original !== undefined && node.nodeValue !== original) {
      node.nodeValue = original;
    }
    originalTextNodes.delete(node);
    return;
  }

  const original = originalTextNodes.get(node) ?? node.nodeValue ?? '';
  const translated = translateUserFacingControlText(language, original);
  if (translated !== original) {
    originalTextNodes.set(node, original);
    if (node.nodeValue !== translated) node.nodeValue = translated;
  }
}

function translateElementAttrs(element: Element, language: Language): void {
  if (isExcluded(element)) return;

  for (const attr of CONTROL_ATTRS) {
    const current = element.getAttribute(attr);
    if (!current) continue;

    if (language === 'en') {
      const attrs = originalAttrs.get(element);
      const original = attrs?.get(attr);
      if (original !== undefined && current !== original) {
        element.setAttribute(attr, original);
      }
      attrs?.delete(attr);
      continue;
    }

    const attrs = originalAttrs.get(element) ?? new Map<string, string>();
    const original = attrs.get(attr) ?? current;
    const translated = translateUserFacingControlText(language, original);
    if (translated !== original) {
      attrs.set(attr, original);
      originalAttrs.set(element, attrs);
      if (current !== translated) element.setAttribute(attr, translated);
    }
  }
}

function walkTextNodes(root: ParentNode, language: Language): void {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();
  while (node) {
    translateTextNode(node as Text, language);
    node = walker.nextNode();
  }
}

export function applyUserFacingControlTranslations(root: ParentNode, language: Language): void {
  if (typeof document === 'undefined') return;
  const rootElement = root instanceof Element ? root : document.body;
  translateElementAttrs(rootElement, language);
  rootElement.querySelectorAll?.(CONTROL_SELECTOR).forEach((element) => {
    translateElementAttrs(element, language);
  });
  walkTextNodes(root, language);
}
